jQuery(document).ready(function () {
    jQuery('#tp-banner-2').revolution({
        delay: 9000, 
        startwidth: 1170, 
        startheight: 500, 
        hideThumbs: 10,
        navigationHAlign : 'center',
        soloArrowLeftHOffset: '0',
        soloArrowRightHOffset : '0',
        soloArrowLeftVOffset : '-50',
        soloArrowRightVOffset : '-50',
        navigationType :'none'
    });
});